var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      {
        staticClass: "nav nav-tabs cf-panel-tab-header cf-panel-lg",
        attrs: { id: "resultTabs" },
      },
      [
        _c("li", { class: [{ active: _vm.viewedResults === "hits" }] }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.showHits },
            },
            [_vm._v("Per Hit")]
          ),
        ]),
        _vm._v(" "),
        _c("li", { class: [{ active: _vm.viewedResults === "docs" }] }, [
          _c(
            "a",
            {
              attrs: { href: "javascript:void(0);" },
              on: { click: _vm.showDocs },
            },
            [_vm._v("Per Document")]
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-content cf-panel-tab-body cf-panel-lg",
        staticStyle: { "padding-top": "0px" },
      },
      [
        _c("results-view", { attrs: { type: "hits" } }),
        _vm._v(" "),
        _c("results-view", { attrs: { type: "docs" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }